const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 48 48.00004"
    },
    viewBox: "0 0 48 48.00004",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons_4_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.00505,8.65502c-8.4801,0-15.3501,6.87-15.3501,15.34c0,8.48,6.87,15.35,15.3501,15.35     c8.47,0,15.34-6.87,15.34-15.35C39.34495,15.52502,32.47505,8.65502,24.00505,8.65502z M29.82495,17.29502c0,0-0.5-0.02-2.2199,0     c-1.68,0.02-1.7001,1.28-1.7001,1.34l-0.02,3.19l3.94,0.08l-0.5799,4.07h-3.3401l-0.0999,8.61h-4.05l-0.1201-8.59l-3.55-0.02     l0.0901-4.15h3.5v-3c0.01-0.32,0.0399-0.64,0.08-0.96c0.0899-0.7,0.2799-1.4,0.61-2.03c0.2899-0.54,0.69-1.02,1.18-1.39     c0.5-0.38,1.0899-0.64,1.7-0.8c0.43-0.12,0.87-0.2,1.31-0.21c0.57-0.02,2.81,0.05,3.37,0.06L29.82495,17.29502z",
    style: {
      fill: "#3B5998"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookBadge);
export default __webpack_public_path__ + "static/media/facebook-badge.6571b8688a125f967a2969311586aca1.svg";
export { ForwardRef as ReactComponent };